import { Timestamp, TranslateFunction } from '@griply/types';
import { format } from 'date-fns';

export const getHabitEndedLabel = (
  endedDate: Timestamp | null | undefined,
  t: TranslateFunction,
): string | null =>
  endedDate
    ? t('general.labels.habit.ended', { date: format(endedDate, 'PP') })
    : null;
